<script setup lang="ts">
import { cn } from "@/lib/utils";

// 1) Expect 'id' from the parent.
const props = defineProps<{ id: string }>();

defineExpose({
  commands: [],
  properties: {
    id: "card-content",
    name: "Card Content",
    icon: "lucide:square-dashed-kanban",
  },
});
</script>

<template>
  <!-- A container for the main card body. -->
  <CardContent :class="cn($attrs.class ?? '')">
    <slot />
  </CardContent>
</template>

<script lang="ts">
import { ComponentDefinitionIds } from "#bb/lib/componentDefinitionIds";
export default {
  componentId: ComponentDefinitionIds.CARD_CONTENT,
  icon: "lucide:square-dashed-kanban",
  type: "Card Content",
  description: "Container block for the main card content.",
  default: {},
  categories: ["Layout"],
  hiddenUntilFiltered: true,
  order: 12010,
};
</script>
